exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "td {\n  padding: 5px;\n  border: 1px solid black; }\n\ntbody:nth-child(even) {\n  background-color: lightblue; }\n\n.scroll-bars {\n  overflow: auto;\n  max-height: 100vh; }\n  .scroll-bars table {\n    margin-bottom: 200px; }\n\n.negative {\n  color: red; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/admin/finance/finance.component.css
// module id = 356
// module chunks = 2